__webpack_require__.p = "/magazine/";